const checkAccessKey = token => {
  return /^[A-Za-z0-9]{24}$/.test(token);
};

const isObject = obj => {
  return typeof obj === 'object' && obj !== null;
};

const parseOrigin = url => {
  if (!url) {
    return '';
  }
  try {
    const parsed = new URL(url);
    return parsed.origin;
  } catch (error) {
    return '';
  }
};

const asyncSleep = ms => new Promise(resolve => setTimeout(resolve, ms));

const defer = Reflect.has(Promise, 'withResolvers')
  ? Promise.withResolvers.bind(Promise)
  : function () {
      let resolve = null;
      let reject = null;
      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });
      return { resolve, reject, promise };
    };

export { checkAccessKey, isObject, parseOrigin, asyncSleep, defer };
